import { render } from "./vendor-profile.vue?vue&type=template&id=309d5d54&scoped=true"
import script from "./vendor-profile.vue?vue&type=script&lang=js"
export * from "./vendor-profile.vue?vue&type=script&lang=js"

import "./vendor-profile.vue?vue&type=style&index=0&id=309d5d54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309d5d54"]])

export default __exports__